import { useQuery } from '@tanstack/react-query';
import { useT } from './useT';
import { getHelpManifest, getHelpTopic, type HelpManifest, type HelpTopic } from '../api/help';

export function useHelpManifest(token: string) {
  const { locale } = useT();
  return useQuery<HelpManifest>({
    queryKey: ['help', 'consumer', 'manifest', token, locale],
    queryFn: () => getHelpManifest(token, locale),
  });
}

export function useHelpTopic(token: string, topicId: string | null) {
  const { locale } = useT();
  return useQuery<HelpTopic>({
    queryKey: ['help', 'consumer', 'topic', token, topicId, locale],
    enabled: topicId !== null,
    queryFn: () => getHelpTopic(token, topicId as string, locale),
  });
}
